module.exports = __webpack_public_path__ + "assets/img/media_16.358c241a.png";